/* product-detail-section.js
   Figma node 2054:2791
   - Gallery: thumbs cross-fade the active image
   - Tabs: Specifications / Care / Shipping
   - Quantity: minus / plus / input
   - Variant: swap UI on swatch click
   - Add to Cart: AJAX with loader state
*/
(function () {
  'use strict';

  document.querySelectorAll('.pdp-section').forEach(initSection);

  function initSection(section) {
    initGallery(section);
    initTabs(section);
    initQuantity(section);
    initSwatches(section);
    initAddToCart(section);
    initSampleButtons(section);
  }

  /* ---------- Shared cart helpers ---------- */

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      var id = el.dataset && el.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  /* Adds a variant to the cart and notifies the theme (cart drawer auto-open,
     header count badge, drawer content morph) via the Horizon `cart:update` event. */
  function addToCart(variantId, qty) {
    var data = new FormData();
    data.append('id', variantId);
    data.append('quantity', qty);
    var ids = cartSectionIds();
    if (ids.length) {
      data.append('sections', ids.join(','));
      data.append('sections_url', window.location.pathname);
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json && json.status && json.message) {
          // Shopify error shape: { status: 422, message, description }
          return { error: true, message: json.description || json.message };
        }
        document.dispatchEvent(new CustomEvent('cart:update', {
          detail: {
            resource: null,
            sourceId: 'product-detail-section',
            data: {
              source: 'product-detail-section',
              itemCount: qty,
              sections: (json && json.sections) || undefined
            }
          }
        }));
        // Legacy event kept for anything still listening to it.
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (window.theme && typeof window.theme.refreshCart === 'function') {
          window.theme.refreshCart();
        }
        return json;
      });
  }

  /* ---------- Gallery ---------- */
  function initGallery(section) {
    var thumbs = section.querySelectorAll('[data-gallery-thumb]');
    var images = section.querySelectorAll('[data-gallery-image]');
    if (!images.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.getAttribute('data-thumb-index'), 10);
        setActiveImage(thumbs, images, idx);
        syncVariantFromImage(section, idx);
      });
    });

    // Clicking the main photo advances to the next image (wrapping), and the
    // colorway selection follows whenever the shown image belongs to a variant.
    var main = section.querySelector('[data-gallery-main]');
    if (main && images.length > 1) {
      main.classList.add('pdp-gallery__main--clickable');
      main.addEventListener('click', function () {
        var current = -1;
        images.forEach(function (im) {
          if (im.classList.contains('is-active')) {
            current = parseInt(im.getAttribute('data-image-index'), 10);
          }
        });
        var next = (current + 1) % images.length;
        setActiveImage(thumbs, images, next);
        syncVariantFromImage(section, next);
      });
    }
  }

  /* When the shown image is some variant's featured image, pull the swatch,
     price, SKU, and cart id along with it — so what you see is what you buy. */
  function syncVariantFromImage(section, idx) {
    var img = section.querySelector('[data-gallery-image][data-image-index="' + idx + '"]');
    if (!img) return;
    var src = (img.getAttribute('src') || '').split('?')[0];
    var variants = getVariants();
    if (!src || !variants) return;
    var match = variants.filter(function (v) {
      return v.featured_image && String(v.featured_image).split('?')[0] === src;
    })[0];
    if (!match) return; // e.g. styled/"with tape" shots that belong to no single colorway
    var swatch = section.querySelector('[data-swatch][data-variant-id="' + match.id + '"]');
    if (!swatch || swatch.classList.contains('is-active')) return;
    if (swatch.getAttribute('aria-disabled') === 'true') return;
    activateSwatch(section, swatch);
  }

  function setActiveImage(thumbs, images, idx) {
    clearVariantOverride(images.length ? images[0].closest('[data-gallery-main]') : null);
    thumbs.forEach(function (t) {
      t.classList.toggle('is-active', parseInt(t.getAttribute('data-thumb-index'), 10) === idx);
    });
    images.forEach(function (img) {
      img.classList.toggle('is-active', parseInt(img.getAttribute('data-image-index'), 10) === idx);
    });
  }

  /* A variant whose image isn't among the rendered gallery images is shown via a
     dedicated overlay element. The indexed images are never mutated — mutating
     them breaks the thumb-index -> image-index mapping for every later click. */
  function clearVariantOverride(main) {
    var override = main && main.querySelector('[data-gallery-override]');
    if (override) override.classList.remove('is-active');
  }

  function showVariantOverride(main, src) {
    if (!main) return;
    var override = main.querySelector('[data-gallery-override]');
    if (!override) {
      override = document.createElement('img');
      override.className = 'pdp-gallery__image';
      override.setAttribute('data-gallery-override', '');
      override.alt = '';
      main.appendChild(override);
    }
    if (override.getAttribute('src') !== src) override.src = src;
    override.classList.add('is-active');
  }

  /* ---------- Tabs ---------- */
  function initTabs(section) {
    var tabsWrap = section.querySelector('[data-tabs]');
    if (!tabsWrap) return;
    var btns = tabsWrap.querySelectorAll('[data-tab]');
    var panels = tabsWrap.querySelectorAll('[data-tab-panel]');

    // World mode (Kevin 8/07): the full specs matter but stay tucked away —
    // start with every panel closed, and clicking the open tab closes it.
    var worldMode = section.classList.contains('pdp-section--world');
    if (worldMode) {
      btns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
      panels.forEach(function (p) { p.classList.remove('is-active'); });
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-tab');
        var closing = worldMode && btn.classList.contains('is-active');
        btns.forEach(function (b) {
          var isActive = !closing && b.getAttribute('data-tab') === key;
          b.classList.toggle('is-active', isActive);
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', !closing && p.getAttribute('data-tab-panel') === key);
        });
      });
    });
  }

  /* ---------- Quantity ---------- */
  function initQuantity(section) {
    var input = section.querySelector('[data-qty-input]');
    var minus = section.querySelector('[data-qty-minus]');
    var plus = section.querySelector('[data-qty-plus]');
    if (!input) return;

    // Cut-yardage minimum (5 narrow / 20 wide) rendered by Liquid as the
    // input's min attribute — the steppers and manual edits clamp to it.
    var qtyMin = parseInt(input.getAttribute('min'), 10) || 1;

    minus && minus.addEventListener('click', function () {
      var v = Math.max(qtyMin, (parseInt(input.value, 10) || qtyMin) - 1);
      input.value = v;
      hideCartError(section);
      updateAtcTotal(section);
    });

    plus && plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || qtyMin) + 1;
      input.value = v;
      hideCartError(section);
      updateAtcTotal(section);
    });

    input.addEventListener('change', function () {
      var v = Math.max(qtyMin, parseInt(input.value, 10) || qtyMin);
      input.value = v;
      hideCartError(section);
      updateAtcTotal(section);
    });

    updateAtcTotal(section);
  }

  /* ---------- Swatches (variant-driven) ---------- */
  function activateSwatch(section, swatch) {
    var swatches = section.querySelectorAll('[data-swatch]');
    var activeColorEl = section.querySelector('[data-active-color]');

    swatches.forEach(function (s) { s.classList.remove('is-active'); });
    swatch.classList.add('is-active');

    var name = swatch.getAttribute('data-color-name');
    if (activeColorEl && name) activeColorEl.textContent = ': ' + name;

    // Let the sample-request buttons re-resolve against the new color.
    section.dispatchEvent(new CustomEvent('pdp:colorchange'));

    var vid = swatch.getAttribute('data-variant-id');
    if (!vid) return;
    var variants = getVariants();
    if (!variants) return;
    var variant = variants.filter(function (v) { return String(v.id) === String(vid); })[0];
    if (variant) {
      updateVariantUI(section, variant);
    }
  }

  function initSwatches(section) {
    var swatches = section.querySelectorAll('[data-swatch]');

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (swatch.getAttribute('aria-disabled') === 'true') return;
        activateSwatch(section, swatch);
      });
    });

    // sync the initial image / price to the pre-selected (active) swatch
    var initial = section.querySelector('[data-swatch].is-active');
    if (initial) {
      var ivid = initial.getAttribute('data-variant-id');
      var vs = getVariants();
      var iv = vs && vs.filter(function (v) { return String(v.id) === String(ivid); })[0];
      if (iv) updateVariantUI(section, iv);
    }
  }

  /* ---------- Add to Cart ---------- */

  /* Cart-rejection line: the cart API's own message (e.g. the cut-minimum
     floor), shown in [data-atc-error] under the CTA group. Until 2026-08-20
     rejections died in console.error — a silent failure on every PDP whose
     rendered minimum drifted below the checkout Function's. */
  function showCartError(section, message) {
    var el = section.querySelector('[data-atc-error]');
    if (!el) return;
    el.textContent = message || 'Sorry — that quantity can’t be added to the cart.';
    el.hidden = false;
  }

  function hideCartError(section) {
    var el = section.querySelector('[data-atc-error]');
    if (el && !el.hidden) { el.hidden = true; el.textContent = ''; }
  }

  function initAddToCart(section) {
    var btn = section.querySelector('[data-atc]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      var qtyInput = section.querySelector('[data-qty-input]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!variantId) return;

      var label = btn.querySelector('[data-atc-label]');
      var loader = btn.querySelector('.pdp-info__cta-loader');
      btn.disabled = true;
      if (label) label.style.opacity = '0.5';
      if (loader) loader.style.display = 'inline-flex';
      hideCartError(section);

      addToCart(variantId, qty)
        .then(function (result) {
          if (result && result.error) {
            console.error('[pdp] add to cart rejected:', result.message);
            showCartError(section, result.message);
          }
        })
        .catch(function (err) {
          console.error('[pdp] add to cart failed:', err);
          showCartError(section, 'Something went wrong adding this to your cart. Please try again.');
        })
        .finally(function () {
          btn.disabled = false;
          if (label) label.style.opacity = '';
          if (loader) loader.style.display = 'none';
        });
    });
  }

  /* ---------- Sample requests: free swatch + full color line ----------
     The 9x9 memo and color-line products are standalone $0 items synced from
     Acumatica. Their handles are derived from the fabric handle + color:
       swatch     ->  9x9-memo-{fabric-handle}-{color-handle}
       color line ->  {fabric-handle}-color-line-memo-set
     The section resolves the initial color's memo and the color-line set
     server-side and stamps data-sample-variant-id; the color line button is
     only rendered when its sample exists.

     On color switch the swatch lookup re-runs here through the SHARED memo
     resolver (assets/memo-chip.js, theme#493): the fabric's memo map
     (product.metafields.asthetik.memo_map, stamped on the section as
     data-memo-map, theme#489) decides with ZERO requests; a fabric not yet
     synced falls back to the /products/9x9-memo-*.js handle ladder. The cache
     is the module's, so the PDP, the card chips in the recommendations rail and
     the collection chips never resolve the same colorway twice. With the module
     absent the local ladder below runs (today's behavior, never a hard dependency).

     State law (theme#487/#488, Rule #138 spirit): the swatch CTA never vanishes
     per colorway. A colorway without a memo turns it into an honest, disabled
     "No swatch in {color}" word (.is-none); a colorway with one flips it back to
     the live label. A cart error is NOT "no swatch": map-sourced ids get ONE
     live re-resolve (stale-map hatch), anything else hands the control back. */
  function initSampleButtons(section) {
    var buttons = section.querySelectorAll('[data-sample-atc]');
    if (!buttons.length) return;

    var resolved = {};   // cache: "swatch:{color}" / "colorline" -> { variantId, fromMap? } | { missing: true }
    var switchSeq = 0;   // guards against out-of-order responses on rapid color switching
    var fabricHandle = section.getAttribute('data-product-handle') || '';
    var memoMap = null;  // parsed data-memo-map (null = fabric not synced -> ladder)
    var memoMapRaw = section.getAttribute('data-memo-map');
    if (memoMapRaw && window.AsthetikMemo && window.AsthetikMemo.parseMemoMap) {
      memoMap = window.AsthetikMemo.parseMemoMap(memoMapRaw);
    }

    function currentColor() {
      var active = section.querySelector('[data-swatch].is-active');
      return (active && active.getAttribute('data-color-name')) || section.getAttribute('data-initial-color') || '';
    }

    function cacheKey(kind) {
      return kind === 'colorline' ? 'colorline' : 'swatch:' + currentColor().toLowerCase();
    }

    buttons.forEach(function (btn) {
      // The live label: stamped by Liquid (the button may render as the honest
      // word for the initial color), else whatever it rendered with.
      if (!btn.getAttribute('data-default-label')) btn.setAttribute('data-default-label', btn.textContent.trim());
      // Seed the cache from the server-resolved variant id (no fetch needed on click).
      var seeded = btn.getAttribute('data-sample-variant-id');
      if (seeded) {
        resolved[cacheKey(btn.getAttribute('data-sample-kind'))] = { variantId: seeded, available: true };
      } else if (btn.getAttribute('data-sample-kind') === 'swatch' && btn.classList.contains('is-none')) {
        resolved[cacheKey('swatch')] = { missing: true }; // Liquid already decided: no memo for the initial color
      }
      btn.addEventListener('click', function () { handleSampleClick(btn); });
    });

    var swatchBtn = section.querySelector('[data-sample-atc][data-sample-kind="swatch"]');

    // On color switch: re-decide the swatch button for the new color. An add in
    // flight keeps its "Adding…" state; its completion re-decides (never a
    // re-enable mid-add, never a tick for a colorway that has no swatch).
    section.addEventListener('pdp:colorchange', function () {
      if (!swatchBtn) return;
      decideSwatch();
    });

    function decideSwatch() {
      var seq = ++switchSeq;
      var color = currentColor();
      if (!swatchBtn.classList.contains('is-loading')) resetSampleButton(swatchBtn);
      resolveSampleVariant('swatch').then(function (res) {
        if (seq !== switchSeq) return; // a newer switch superseded this lookup
        if (swatchBtn.classList.contains('is-loading')) return; // the add's completion paints
        paintSwatch(res, color);
      });
    }

    function paintSwatch(res, color) {
      if (res.missing || res.available === false) setSampleNone(swatchBtn, color);
      else resetSampleButton(swatchBtn);
    }

    function resetSampleButton(btn) {
      btn.hidden = false;
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('is-loading', 'is-added', 'is-unavailable', 'is-none');
      btn.textContent = btn.getAttribute('data-default-label');
    }

    // The honest word for a colorway with no memo (theme#488 law): visible,
    // disabled, says so. Flips back to the live label on a colorway that has one.
    function setSampleNone(btn, color) {
      btn.hidden = false;
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.remove('is-loading', 'is-added', 'is-unavailable');
      btn.classList.add('is-none');
      btn.textContent = color ? 'No swatch in ' + color : 'No swatch';
    }

    function handleize(str) {
      return String(str).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }

    function candidateHandles(kind) {
      var base = fabricHandle;
      if (!base) return [];
      if (kind === 'colorline') {
        return [base + '-color-line-memo-set'];
      }
      var color = currentColor();
      if (!color) return ['9x9-memo-' + base];
      var handles = ['9x9-memo-' + base + '-' + handleize(color)];
      var squashed = '9x9-memo-' + base + '-' + handleize(color.replace(/\s+/g, ''));
      if (handles.indexOf(squashed) === -1) handles.push(squashed);
      return handles;
    }

    function resolveSampleVariant(kind) {
      var key = cacheKey(kind);
      if (resolved[key]) return Promise.resolve(resolved[key]);

      // Swatch lookups go through the shared resolver when it is loaded: the
      // memo map answers without a request; otherwise its ladder (one cache
      // with every chip on the page). The color-line set and a color-less
      // fabric keep the local ladder.
      var color = currentColor();
      if (kind === 'swatch' && color && fabricHandle && window.AsthetikMemo && window.AsthetikMemo.resolve) {
        return window.AsthetikMemo.resolve(fabricHandle, color, memoMap).then(function (res) {
          resolved[key] = res;
          return res;
        });
      }

      var handles = candidateHandles(kind);
      function attempt(i) {
        if (i >= handles.length) return Promise.resolve({ missing: true });
        return fetch('/products/' + handles[i] + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) {
            if (!r.ok) return attempt(i + 1);
            return r.json().then(function (p) {
              var variants = p.variants || [];
              var v = variants.filter(function (x) { return x.available; })[0] || variants[0];
              if (!v) return attempt(i + 1);
              return { variantId: v.id, available: !!v.available };
            });
          })
          .catch(function () { return attempt(i + 1); });
      }

      return attempt(0).then(function (res) {
        resolved[key] = res;
        return res;
      });
    }

    function handleSampleClick(btn) {
      if (btn.disabled) return;
      var kind = btn.getAttribute('data-sample-kind');
      var seq = switchSeq;           // the colorway this click was made for
      var color = currentColor();
      var key = cacheKey(kind);
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.textContent = 'Adding…';

      function finishAdded() {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = 'Added to cart ✓';
        setTimeout(function () {
          if (!btn.classList.contains('is-added')) return;
          resetSampleButton(btn);
          if (kind === 'swatch') decideSwatch(); // the tick expiring re-decides; it never blindly restores the live label
        }, 2600);
      }
      function finishUnavailable() {
        btn.classList.remove('is-loading');
        btn.classList.add('is-unavailable');
        btn.textContent = 'Currently unavailable';
      }
      function finishMissing() {
        // Shouldn't normally happen (the button is decided before the click), but
        // covers the race where stock/state changed after render.
        if (kind === 'swatch') setSampleNone(btn, color);
        else { resetSampleButton(btn); btn.hidden = true; } // color line: color-independent, so missing = gone
      }
      // After the add settles, a colorway switched mid-flight owns the button.
      function superseded() { return kind === 'swatch' && seq !== switchSeq; }

      resolveSampleVariant(kind)
        .then(function (res) {
          if (res.missing || res.available === false) { finishMissing(); return null; }
          return addToCart(res.variantId, 1).then(function (result) {
            if (!(result && result.error)) { if (superseded()) { btn.classList.remove('is-loading'); decideSwatch(); } else finishAdded(); return; }
            // Stale-map hatch: a map-sourced id the cart refuses gets ONE live
            // re-resolve. A different purchasable memo -> add that; none -> the
            // honest word; the same id -> a real cart error, say so.
            if (res.fromMap && kind === 'swatch' && window.AsthetikMemo && window.AsthetikMemo.refresh) {
              return window.AsthetikMemo.refresh(fabricHandle, color).then(function (fresh) {
                resolved[key] = fresh;
                if (fresh.missing) { finishMissing(); return; }
                if (String(fresh.variantId) === String(res.variantId)) { finishUnavailable(); return; }
                return addToCart(fresh.variantId, 1).then(function (again) {
                  if (again && again.error) { finishUnavailable(); return; }
                  if (superseded()) { btn.classList.remove('is-loading'); decideSwatch(); } else finishAdded();
                });
              });
            }
            finishUnavailable();
          });
        })
        .catch(function (err) {
          console.error('[pdp] sample request failed:', err);
          resetSampleButton(btn);
          if (kind === 'swatch' && superseded()) decideSwatch();
        });
    }
  }

  /* ---------- Variant UI ---------- */
  function getVariants() {
    var el = document.querySelector('[data-pdp-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function formatMoney(cents, suffix) {
    var dollars = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + dollars + (suffix || '');
  }

  function updateVariantUI(section, variant) {
    if (!variant) return;
    var pdp = section;
    var priceCurrent = pdp.querySelector('[data-price-current]');
    var priceCompare = pdp.querySelector('[data-price-compare]');
    var skuRow = pdp.querySelector('[data-sku-row]');
    var skuValue = pdp.querySelector('[data-sku-value]');
    var atc = pdp.querySelector('[data-atc]');

    if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
    if (priceCompare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceCompare.textContent = formatMoney(variant.compare_at_price);
        priceCompare.style.display = '';
      } else {
        priceCompare.style.display = 'none';
      }
    }
    if (variant.sku) {
      if (skuValue) skuValue.textContent = variant.sku;
      if (skuRow) skuRow.style.display = '';
    } else if (skuRow) {
      skuRow.style.display = 'none';
    }
    if (atc) atc.setAttribute('data-variant-id', variant.id);
    setVariantImage(section, variant);
    updateAtcTotal(section, variant.price);
  }

  function setVariantImage(section, variant) {
    if (!variant || !variant.featured_image) return;
    var main = section.querySelector('[data-gallery-main]');
    var imgs = section.querySelectorAll('[data-gallery-image]');
    if (!imgs.length) return;
    var thumbs = section.querySelectorAll('[data-gallery-thumb]');
    var target = String(variant.featured_image).split('?')[0];
    var matched = -1;
    imgs.forEach(function (im) {
      if ((im.getAttribute('src') || '').split('?')[0] === target) {
        matched = parseInt(im.getAttribute('data-image-index'), 10);
      }
    });
    if (matched >= 0) {
      clearVariantOverride(main);
      imgs.forEach(function (im) {
        im.classList.toggle('is-active', parseInt(im.getAttribute('data-image-index'), 10) === matched);
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-thumb-index'), 10) === matched);
      });
    } else {
      // Variant image isn't rendered in the gallery — show it on the overlay
      // element and drop the active state from the indexed images/thumbs.
      showVariantOverride(main, variant.featured_image);
      imgs.forEach(function (im) { im.classList.remove('is-active'); });
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    }
  }

  function updateAtcTotal(section, priceOverride) {
    var atc = section.querySelector('[data-atc]');
    var totalEl = atc && atc.querySelector('[data-atc-total]');
    var qtyInput = section.querySelector('[data-qty-input]');
    if (!atc || !totalEl) return;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var price;
    if (priceOverride !== undefined) {
      price = priceOverride;
    } else {
      var variants = getVariants();
      var vid = atc.getAttribute('data-variant-id');
      if (variants) {
        var match = variants.filter(function (v) { return String(v.id) === String(vid); })[0];
        price = match ? match.price : null;
      }
    }
    if (price == null) return;
    totalEl.textContent = formatMoney(price * qty);
  }
})();
